import React, { useEffect, useLayoutEffect } from "react";

import useToggle from "../frontend/hooks/useToggle";
import Logo from "../frontend/assets/diakonhjemmet_logo.svg";
import LogoOmsorg from "../frontend/assets/diakonhjemmet_logo_omsorg.svg";

interface HeaderProps {
  topLinkTitle: string;
  topLinkUrl: string;
  topLinkType: string;

  linkLogo: string;
  topLinkShow: boolean;
  thema: string;
  sticky?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  topLinkTitle,
  topLinkUrl,
  topLinkType,

  linkLogo,
  topLinkShow,
  thema,
  sticky = false,
}) => {
  const [menuOpen, toggleMenu, setMenu] = useToggle();

  useEffect(() => {
    window.scrollTo(0, 0);
    setMenu(false);
  }, [setMenu]);

  useLayoutEffect(() => {
    if (menuOpen) {
      window.scrollTo(0, 0);
      const offset =
        window.innerWidth - document.body.getBoundingClientRect().width;
      document.body.style.marginRight = offset ? `${offset}px` : "";
    } else {
      document.body.style.marginRight = "";
    }
    document.body.classList.toggle("menu-open", menuOpen);
  }, [menuOpen]);

  let target = "";
  if (topLinkType == "external") {
    target = "_blank";
  }

  return (
    <header className={`site-header${sticky ? " site-header--sticky" : ""}`}>
      <a href={linkLogo} aria-label="Forside" className="main-logo">
        {thema === "diakonhjemmet" && <Logo />}
        {thema === "diakonhjemmetOmsorg" && <LogoOmsorg />}
      </a>
      {topLinkShow && (
        <a href={topLinkUrl} target={target} className="header-cta-btn">
          {topLinkTitle}
        </a>
      )}

      <button
        className="menu-btn"
        onClick={toggleMenu}
        aria-label={menuOpen ? "Lukk" : "Meny"}
      />
    </header>
  );
};

export default Header;
